import { Box, Tab, Tabs } from '@mui/material';
import styled from 'styled-components';

export const Container = styled(Box)`
  border-bottom: 1px;
  border-color: divider;
  max-width: 800px;
  width: 100%;
`;

export const CustomTabList = styled(Tabs)`
  .MuiTabs-indicator {
    height: 5px;
  }
`;

export const CustomTab = styled(Tab)<{ $tabWidth: string }>`
  font-style: normal;
  font-weight: 700;
  font-size: 12px;
  line-height: 17px;
  color: #cccccc;
  min-width: ${({ $tabWidth }) => $tabWidth};
`;
